import { ProfileSectionProps } from './types';

const ProfileSection = (props: ProfileSectionProps) => {
  const {
    children,
    title
  } = props;

  return (
    <section className="space-y-4">
      <h2 className="truncate font-sans text-[18px] font-semibold leading-6 tracking-normal text-foreground">
        {title}
      </h2>
      {children}
    </section>
  );
};

export default ProfileSection;